import EditNoteIcon from '@assets/icons/edit-note.svg';
import i18n from '@/utils/i18n';
import React from 'react';
import { OrderGuideRightAction } from './order-guide-right-action';
import { TrackingData } from '@/utils/analytics/base-reporter';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  onPress: () => void;
  trackingData?: TrackingData;
}

export const AddNoteRightAction: React.FC<Props> = ({
  onPress,
  trackingData,
}) => {
  const theme = useTheme();

  return (
    <OrderGuideRightAction
      backgroundColor={theme.colors.pepperGreen}
      Icon={EditNoteIcon}
      iconProps={{ fill: theme.colors.primary }}
      onPress={onPress}
      text={i18n.t('add_note_line_break')}
      trackingData={trackingData ?? null}
    />
  );
};
